import { lottiesPaths } from 'Constants/lottiesPaths';
import { ResultTypes } from 'Types/common';

export const lottieDictionary = {
  [ResultTypes.toReturn]: lottiesPaths.FILED,
  [ResultTypes.equal]: lottiesPaths.FILED_NOT_RETURN,
  [ResultTypes.toPay]: lottiesPaths.FILED_NOT_RETURN,
};
